export default "<p>sidebaradmin works!</p>\n"